import React from 'react';
import { useSelector } from 'react-redux';
import { Select } from 'ui/components';

import { Form } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

const initialState = {
  isLoading: true,
  name: '',
  company_name: '',
  pic_name: '',
  pic_phone: '',
  pic_email: '',
  address: '',
  entities: '',
};

const options = [
  { value: 'community', label: 'Community' },
  { value: 'personal', label: 'Personal' },
  { value: 'corporate', label: 'Corporate' },
  { value: 'instansi', label: 'Instansi' },
];

export const FormBulkUpdate = ({ data, onSubmit, onClose }) => {
  const StateForm = useSelector((state) => state.Form);
  const dummy = Array.from({ length: 6 }, (v, i) => i);

  const [
    {
      isLoading,
      name,
      company_name,
      pic_name,
      pic_phone,
      pic_email,
      address,
      entities,
    },
    setState,
  ] = React.useState(initialState);

  const $onSave = async (c) => {
    const payload = {
      name,
      company_name,
      pic_name,
      pic_phone,
      pic_email,
      address,
      entities: entities?.value,
      type: 'vendor'
    };

    onSubmit(payload);
  };

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }, 2000);
  }, [isLoading]);

  React.useEffect(() => {
    if (!data) return;
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
    }));

    const e =
      data?.entities === 'community'
        ? options[0]
        : data?.entities === 'personal'
        ? options[1]
        : data?.entities === 'corporate'
        ? options[2]
        : data?.entities === 'instansi'
        ? options[3]
        : null;

    setState((prevState) => ({
      ...prevState,
      name: data?.name,
      company_name: data?.company_name,
      pic_name: data?.pic_name,
      pic_phone: data?.pic_phone,
      pic_email: data?.pic_email,
      address: data?.address,
      entities: e,
    }));
  }, [data]);

  if (isLoading) {
    return (
      <div className="row m-0">
        {dummy?.map((d, i) => (
          <div key={i} className="col-md-6">
            <SkeletonsForm count={1} key={i} />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="px-3 pt-4 pb-3 bg-white my-3 border rounded-2">
      <div className="row text-start">
        <div className="col-12">
          <div className="hr-text hr-text-left text-primary mb-3 ">
            Perbaharui
          </div>
        </div>
        <div className="col-md-6">
          <div className="mb-3">
            <label className="form-label required">Entities</label>
            <Select
              isClearable
              classNamePrefix={
                StateForm?.errors?.entities ? 'is-invalid' : 'select'
              }
              placeholder=""
              value={entities}
              options={options}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  entities: e,
                }))
              }
            />

            {StateForm?.errors?.entities ? (
              <div className="invalid-feedback" style={{ display: 'block' }}>
                {StateForm?.errors?.entities}
              </div>
            ) : null}
          </div>

          <Form.Input
            required
            value={name}
            onChange={(e) =>
              setState((prevState) => ({ ...prevState, name: e.target.value }))
            }
            error={StateForm?.errors?.name}
            type="text"
            label="Nama Vendor"
          />

          <Form.Input
            label="Nama Perusahaan"
            type="text"
            value={company_name}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                company_name: e.target.value,
              }))
            }
            error={StateForm?.errors?.company_name}
          />

          <Form.Textbox
            required
            value={address}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                address: e.target.value,
              }))
            }
            error={StateForm?.errors?.address}
            rows={4}
            label="Alamat Vendor"
          />
        </div>
        <div className="col-md-6">
          <Form.Input
            required
            value={pic_name}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                pic_name: e.target.value,
              }))
            }
            error={StateForm?.errors?.pic_name}
            type="text"
            label="Nama Penanggung Jawab"
          />
          <Form.Input
            required
            value={pic_phone}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                pic_phone: e.target.value,
              }))
            }
            error={StateForm?.errors?.pic_phone}
            type="phone"
            label="Nomor HP Penanggung Jawab"
          />

          <Form.Input
            required
            value={pic_email}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                pic_email: e.target.value,
              }))
            }
            error={StateForm?.errors?.pic_email}
            type="email"
            label="Email Penanggung Jawab "
          />
        </div>
      </div>

      <div className="d-flex justify-content-end align-items-center gap-3 border-top mt-4 pt-3 mb-0">
        <div
          className="btn btn-primary btn-sm rounded-2 px-5 "
          onClick={$onSave}
        >
          Simpan Perubahan
        </div>
        <div className="btn btn-danger btn-sm rounded-2 px-5" onClick={onClose}>
          Batal
        </div>
      </div>
    </div>
  );
};
